import OfferEvent from '@core/models/offer/OfferEvent';
import { sortBy } from '@core/utils/sort/sortBy';
import { shellLocalConfig } from '@src/config/shell/localConfig';

import gamingGetters from './gaming/getters';
import {
    IFavouriteTournament,
    IUserPreferences,
    Getters,
    DEFAULT_USER_ID,
    PredefinedStake,
} from './types';
import { getConfig } from '@superbet-group/web.lib.config';

const getters: Getters = {
    tournaments(_state, getters, _rootState, rootGetters): IFavouriteTournament[] {
        return getters._userState.favouriteTournaments
            .filter((id: number) => !!rootGetters['data/sportOffer/tournaments'][id])
            .map((id: number) => {
                const tournament = rootGetters['data/sportOffer/tournaments'][id];

                return {
                    id: tournament.id,
                    displayName: tournament.name,
                };
            });
    },
    tournamentsEvents(_state, getters, rootState, rootGetters) {
        const events = rootGetters['data/sportOffer/events']
            .filter((event: OfferEvent) =>
                !!getters._userState.favouriteTournaments.find((id: number) => id === event.tournamentId)
                && !event.isFinished() && !event.isStopped());
        return sortBy(events, shellLocalConfig.sportOfferSort.getEventSortRules());
    },
    tournamentIds(_state, getters) {
        return getters._userState.favouriteTournaments;
    },
    marketIds(_state, getters) {
        return getters._userState.favouriteMarkets;
    },
    _userState(state, getters): IUserPreferences {
        return state[getters._userId];
    },
    _userId(_state, _getters, _rootState, rootGetters) {
        const user = rootGetters['data/authentication/user'];
        return user ? user.userId : DEFAULT_USER_ID;
    },
    pinnedEventIds: (_state, getters) => {
        return getters._userState?.pinnedEvents ?? [];
    },
    pinnedEvents: (_state, getters, _rootState, rootGetters) => {
        const events = rootGetters['data/sportOffer/eventsMap'];
        return getters.pinnedEventIds.map((id: number) => events[id]).filter((event) => !!event);
    },
    deleteBetslipAfterPurchase: (_state, getters): boolean => {
        return getters._userState.betslipPreferences?.shouldDeleteBetslipAfterPurchase ?? true;
    },
    predefinedStakes: (_state, getters): PredefinedStake[] => {
        return getters._userState.betslipPreferences?.predefinedStakes ?? getConfig().betSlip.predefinedStakes?.map((value, index) => {
            return {
                value,
                index,
            };
        });
    },
    ...gamingGetters,
};

export default getters;
